<script>
import SearchResultsTabStores from '@phoenix/mixins/components/search/SearchResultsTabStores';
import SearchResultsTab from '@maison/components/search/SearchResultsTab';
import StoreCard from '@maison/components/store/StoreCard';
import { algoliaTracking } from '@module/Algolia/resources/js/insights/helpers';
import { IndexNames } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import searchResultsTrackingMixin from '@maison/mixins/searchResultsTrackingMixin';
import { mapActions } from 'vuex';
import { PhxIcon } from '@phx-styleguides/jlc';
import Store from '@phoenix/components/Store';

export default {
  components: {
    SearchResultsTab,
    StoreCard,
    PhxIcon,
  },

  mixins: [SearchResultsTabStores, searchResultsTrackingMixin],

  computed: {
    storeSearchUrl() {
      return window.route('boutiques');
    },

    stores() {
      return this.boutiques.concat(this.retailers);
    },
  },

  methods: {
    ...mapActions('search', ['setHasInteractedWithResults']),

    onStoreClick(store, index) {
      this.setHasInteractedWithResults();
      algoliaTracking(store, index, IndexNames.Stores);

      this.sendSearchClickTracking(this.query, store.permalink, index, 'store');
    },

    getStatus(store) {
      return new Store(store.openingHours, store.specialDays, store.timezone, store.isOnline).status;
    },
  },
};
</script>

<template>
  <search-results-tab :tab="tab" :limit="limit">
    <div v-if="storeSearchUrl" class="my-lg text-center">
      <a :href="storeSearchUrl" type="button" class="btn btn--default btn--icon btn--negative">
        <span class="btn__text">{{ $t('Search.stores.findABoutique') }}</span>

        <span class="btn__icon btn__icon--end">
          <phx-icon icon="pin-16" />
        </span>
      </a>
    </div>

    <div class="container">
      <div class="boutique-cards__grid">
        <store-card
          v-for="(store, index) in stores"
          :key="store.id"
          :address="store.fullAddress"
          :image="store.rokkaImg"
          :title="store.name"
          :status="getStatus(store)"
          :phone="store.phone"
          :permalink="store.permalink"
          :is-online="store.isOnline"
          :see-more-label="store.seeMoreLabel"
          :is-reseller="store.isReseller"
          :is-repairer="store.isRepairer"
          :services="store.services"
          @click="onStoreClick(store, index)"
        />
      </div>
    </div>
  </search-results-tab>
</template>
